/** Word-level IPA overrides for Romanian. */
export const ro: Record<string, string> = {
  // New sample overrides
  admirabilă: '/admiraˈbilə/',
  aleargă: '/aˈle̯argə/',
  alergi: '/aˈlerdʒʲ/',
  Armadia: '/arˈmadja/',
  băieșaș: '/bəjeˈʃaʃ/',
  'ca-ntr-un': '/kanˈtrun/',
  Cârlibaba: '/kɨrliˈbaba/',
  ciobănei: '/tʃobəˈnej/',
  cioplește: '/tʃoˈpleʃte/',
  cirezilor: '/tʃiˈrezilor/',
  clădi: '/kləˈdʲi/',
  codrul: '/ˈkodrul/',
  crengi: '/krendʒʲ/',
  'croiește-ți': '/kroˈjeʃtetʃi/',
  curată: '/kuˈratə/',
  deshame: '/desˈhame/',
  desprind: '/desˈprind/',
  'Deșteaptă-te': '/deʃˈte̯aptəte/',
  fecioara: '/fetʃoˈara/',
  ferestrelor: '/feˈrestrelor/',
  furtunoasă: '/furtuˈno̯asə/',
  gemând: '/dʒeˈmɨnd/',
  grupurile: '/ˈɡrupurile/',
  homer: '/ˈhomer/',
  humuleștii: '/humuˈleʃti.i/',
  începusem: '/ɨntʃeˈpusem/',
  întinsese: '/ɨntinˈsese/',
  întovărășind: '/ɨntovərəˈʃind/',
  intrată: '/inˈtratə/',
  Jidovița: '/ʒidoˈvitsə/',
  'l-a': '/la/',
  'le-ntâlnesc': '/lentɨlˈnesk/',
  luasem: '/luˈasem/',
  lustruiește: '/lustruˈjeʃte/',
  'mână-n': '/ˈmɨnən/',
  'mândră-n': '/ˈmɨndrən/',
  morminte: '/morˈminte/',
  mucegăită: '/mutʃeɡəˈitə/',
  națională: '/natsioˈnalə/',
  Obloanele: '/oblo̯aˈnele/',
  'ochiu-adormit': '/ˈokju adorˈmit/',
  paraschi: '/paraˈski/',
  părinților: '/pəˈrintsilor/',
  'pe-ntinsele': '/pentinˈsele/',
  Prahovei: '/praˈhovej/',
  răsar: '/rəˈsar/',
  răzuiește: '/rəzuˈjeʃte/',
  răzvrătită: '/rəzvrəˈtitə/',

  scârțâiau: '/skɨrtsɨˈjaw/',
  scârțâie: '/skɨrˈtsɨje/',
  scoală: '/ˈsko̯alə/',
  scrumit: '/skruˈmit/',
  scuipat: '/skuiˈpat/',
  'se-nchine': '/senˈkine/',
  sfinți: '/sfintsʲ/',
  sicriele: '/siˈkrijele/',
  socoate: '/soˈko̯ate/',
  Someșul: '/ˈsomeʃul/',
  șoseaua: '/ʃoˈse̯awa/',
  stam: '/stam/',
  strivesc: '/striˈvesk/',
  sublocotenent: '/sublokoteˈnent/',
  tăind: '/təˈind/',
  tainele: '/ˈtajnele/',
  'te-adânciră': '/teadɨnˈtʃirə/',
  'toate-s': '/ˈto̯ates/',
  trăsnesc: '/trəsˈnesk/',
  ucid: '/uˈtʃid/',
  uneltele: '/uˈneltele/',
  văii: '/ˈvəji/',
  vânturată: '/vɨntuˈratə/',
  veștmânt: '/veʃtˈmɨnt/',
  'vijelia-ngrozitoare': '/viˈʒeli.a ŋɡroziˈto̯are/',
  'Vino-n': '/viˈnon/',
};
